import * as React from "react";
import Head from "next/head";
import Footer from "../components/Footer";
import Parties from "../components/EventTypes/parties";
import Layout from "../components/Layout";
import Header from "../components/Header";
import VendorBar from "../components/VendorBar";

export default function IndexRoute() {
  return (
    <>
        <Head>
            <title>What&#39;s Included with TacBoard.</title>
            <meta name="description" content="Sign up now and receive your live photo stream, unique phone number, online gallery and free sign shop." />
            <link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Aleo:200,300,400,700|Montserrat:300,400,500,700" />
                <link rel="canonical" href="https://tacboard.com/whats-included-with-tacboard" />
        </Head>

      <Layout classes={["event-types", "public"]}>
        <Header />
        <Parties />
        <VendorBar />
        <Footer />
      </Layout>
    </>
  );
};
